// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1D6Ty","noInteraction":"EventWrapper_noInteraction__32nXf"};